<section
  class="modal"
  role="dialog"
  aria-modal="true"
  aria-labelledby="join-modal-title"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
>
  @if (step() === 'loading') {
    <div class="modal-loading" role="status" aria-live="polite">
      <h1 id="join-modal-title">We're Stitching everything together.</h1>
      <span></span>
    </div>
  } @else {
    <button class="close" type="button" aria-label="Close join window" (click)="dismiss()">×</button>
    <div class="form-half">
      <img class="modal-wordmark" src="assets/logo-with-text.svg" alt="Stitch.ai" />
      <div class="form-scroll">
        @if (invitation(); as invitation) {
          @if (step() === 'name') {
            <h1 id="join-modal-title">Join {{ invitation.teamTitle }}’s<br />Team Workspace</h1>
            <p>Your first name and last name will be visible to your teammates and anybody you send an email to.</p>
            <form [formGroup]="form" (ngSubmit)="next()">
              <div class="name-row">
                <label
                  >First name<input formControlName="firstName" placeholder="First name" autocomplete="given-name"
                /></label>
                <label
                  >Last name<input formControlName="lastName" placeholder="Last name" autocomplete="family-name"
                /></label>
              </div>
              <div class="actions">
                <button class="secondary" type="button" (click)="dismiss()">Back</button
                ><button
                  class="primary"
                  type="submit"
                  [disabled]="form.controls.firstName.invalid || form.controls.lastName.invalid"
                >
                  Next
                </button>
              </div>
            </form>
          } @else {
            <h1 id="join-modal-title">Choose your team email address</h1>
            <p>Your team email address will be visible to your teammates and anybody you send an email to.</p>
            <hr />
            <form [formGroup]="form" (ngSubmit)="accept()">
              <label
                >Create your team workspace email address
                <span
                  class="address-input"
                  [class.address-input--error]="availability() === 'taken' || availability() === 'invalid'"
                >
                  <input
                    formControlName="teamEmailLocalPart"
                    placeholder="Enter email address"
                    autocomplete="username"
                    autocapitalize="none"
                    autocorrect="off"
                    spellcheck="false"
                    aria-describedby="modal-address-status"
                  />
                  <strong [class.available]="availability() === 'available'">&#64;{{ invitation.teamHostname }}</strong>
                  @if (availability() === 'available') {
                    <i aria-hidden="true">✓</i>
                  }
                </span>
              </label>
              <p
                id="modal-address-status"
                class="status"
                aria-live="polite"
                [class.error]="
                  availability() === 'taken' || availability() === 'invalid' || availability() === 'network'
                "
              >
                @switch (availability()) {
                  @case ('pending') {
                    Checking address…
                  }
                  @case ('available') {
                    Email address is available
                  }
                  @case ('taken') {
                    This email address is taken. Please choose a different one.
                  }
                  @case ('invalid') {
                    Please enter a valid email address.
                  }
                  @case ('network') {
                    We couldn’t check this address. Please try again.
                  }
                }
              </p>
              @if (error()) {
                <p class="error" role="alert">{{ error() }}</p>
                @if (useSignupFailure()) {
                  <a [href]="publicInvitationPath">Open invitation</a>
                }
              }
              <div class="actions">
                <button class="secondary" type="button" (click)="step.set('name')">Back</button
                ><button class="primary" type="submit" [disabled]="availability() !== 'available'">
                  Join the team
                </button>
              </div>
            </form>
          }
        } @else if (error()) {
          <h1 id="join-modal-title" class="visually-hidden">Join a team workspace</h1>
          <p class="error" role="alert">{{ error() }}</p>
        } @else {
          <h1 id="join-modal-title" class="visually-hidden">Join a team workspace</h1>
          <p role="status" aria-live="polite">Loading invitation…</p>
        }
      </div>
    </div>
    <aside class="art-half" aria-hidden="true">
      <div class="privacy"><span>i</span>Nothing in your personal space is shared with your team.</div>
      <img src="assets/login/welcome.svg" alt="" />
    </aside>
  }
</section>
